import apiClient from "core/api/apiClient";
import { handleResponse } from "utils/responseHandler";

class CategoryService {
  /**
   * Get all custom categories for a specific teacher
   */
  async getTeacherCategories(teacherId) {
    try {
      const response = await handleResponse(apiClient.get(`/categories/teacher/${teacherId}`));
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw error;
    }
  }

  /**
   * Get all categories for the currently authenticated teacher
   */
  async getMyCategories(parentSlug = null) {
    try {
      const params = parentSlug ? { parentSlug } : {};
      const response = await handleResponse(apiClient.get("/categories/my", { params }));
      return response.data;
    } catch (error) {
      console.error("Error fetching my categories:", error);
      throw error;
    }
  }

  /**
   * Create a new custom category
   */
  async createCategory(data) {
    try {
      const response = await handleResponse(apiClient.post("/categories", data));
      return response.data;
    } catch (error) {
      console.error("Error creating category:", error);
      throw error;
    }
  }

  /**
   * Update an existing category
   */
  async updateCategory(id, data) {
    try {
      const response = await handleResponse(apiClient.put(`/categories/${id}`, data));
      return response.data;
    } catch (error) {
      console.error("Error updating category:", error);
      throw error;
    }
  }

  /**
   * Delete a custom category
   */
  async deleteCategory(id) {
    try {
      const response = await handleResponse(apiClient.delete(`/categories/${id}`));
      return response.data;
    } catch (error) {
      console.error("Error deleting category:", error);
      throw error;
    }
  }

  /**
   * Update ordering of categories (Bulk)
   */
  async reorderCategories(categoriesData) {
    try {
      const response = await handleResponse(apiClient.put("/categories/order", { categories: categoriesData }));
      return response.data;
    } catch (error) {
      console.error("Error reordering categories:", error);
      throw error;
    }
  }
}

export default new CategoryService();
